var React = require('react');
var { Input } = require('@metro-ui/core');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var createReactClass = require('create-react-class');
var defaultMessages = require('../../i18n/messages/default');
var LoginPreferencesCardWrapper = require('./LoginPreferencesCardWrapper');

var UserCredentials = createReactClass({
    displayName: 'UserCredentials',
    render: function(){
        return (
            <LoginPreferencesCardWrapper headingText= {this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials'])}> 
                <Input
                    value={this.props.email}
                    label={this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials.email'])}
                    isReadOnly={true}
                    placeholder={this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials.email'])}
                    type="text"/>
                <Input
                    value={'**********'}
                    label={this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials.password'])}
                    isReadOnly={true}
                    placeholder={this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials.password'])}
                    type="text"/>
            </LoginPreferencesCardWrapper>
        )
    }
});

module.exports= injectIntl(UserCredentials);
